import React from "react";
import { FAQS } from "@/lib/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="mx-auto max-w-5xl px-6 lg:px-12">
        <div className="text-center max-w-xl mx-auto">
          <div className="text-xs uppercase tracking-[0.28em] text-[#B35B47]">— Gentle questions</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#2C302E] leading-[1.05]">
            Before you arrive
          </h2>
          <p className="mt-5 text-[#5C605A]">
            Everything you might be wondering, answered with care.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-14">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#EAE5D9] last:border-b"
            >
              <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-[#2C302E] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5C605A] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
